"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLockSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M51.29 30.22H50v-6.83c0-8.66-6.73-15.71-15-15.71s-15 7-15 15.71v6.83h-1.29a3.33 3.33 0 0 0-3.33 3.33V59a3.33 3.33 0 0 0 3.33 3.33h32.58A3.33 3.33 0 0 0 54.63 59V33.55a3.33 3.33 0 0 0-3.34-3.33zM24 23.39c0-6.45 4.93-11.71 11-11.71s11 5.25 11 11.71v6.83H24zm13.48 24.84l1.62 7.85H31l1.62-7.85.38-1.89L31.61 45a4.87 4.87 0 1 1 6.85 0l-1.37 1.35z"
  })),
  height: undefined,
  width: undefined
});
IconLockSolid.displayName = 'IconLockSolid';
var _default = IconLockSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/lock-solid.js
// module id = 342
// module chunks = 0